import React, { useContext, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Navbar, Nav } from 'react-bootstrap';
import classNames from 'classnames';
import AppContext from 'context/Context';
import Logo from 'components/common/Logo';
import SearchBox from './SearchBox';
import NavbarTopDropDownMenus from './NavbarTopDropDownMenus';
import { navbarBreakPoint, topNavbarBreakpoint } from 'config';
import autoCompleteInitialItem from 'data/autocomplete/autocomplete';
import TopNavRightSideNavItem from './TopNavRightSideNavItem';
import { useLocation } from 'react-router-dom';

const NavbarTop = ({
    notificaciones,
    notificacionesLiberados,
    setIdLead,
    setShowModalSeguimientoLead,
    isAllRead,
    setIsAllRead,
    isAllReadLiberados,
    setIsAllReadLiberados,
    obtenerNotificaciones,
    hayNotificacionesNoLeidas,
    lastNotf,
    lastNotfLiberados,
    setShowReleaseModal
    //isModalOpen,
    //setIsModalOpen
}) => {
    const {
        config: { showBurgerMenu, navbarPosition, navbarCollapsed },
        setConfig
    } = useContext(AppContext);

    const { pathname } = useLocation();
    const isChat = pathname.includes('chat');

    const [showDropShadow, setShowDropShadow] = useState(false);

    const handleBurgerMenu = () => {
        (navbarPosition === 'top' || navbarPosition === 'double-top') &&
            setConfig('navbarCollapsed', !navbarCollapsed);
        (navbarPosition === 'vertical' || navbarPosition === 'combo') &&
            setConfig('showBurgerMenu', !showBurgerMenu);
    };

    const setDropShadow = () => {
        const el = document.documentElement;
        if (el.scrollTop > 0) {
            setShowDropShadow(true);
        } else {
            setShowDropShadow(false);
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', setDropShadow);
        return () => window.removeEventListener('scroll', setDropShadow);
    }, []);

    const burgerMenuRef = useRef();

    return (
        <Navbar
            className={classNames('navbar-glass fs--1 navbar-top sticky-kit', {
                // 'navbar-glass-shadow': showDropShadow
                'navbar-glass-shadow': showDropShadow && !isChat
            })}
            expand={
                navbarPosition === 'top' ||
                    navbarPosition === 'combo' ||
                    navbarPosition === 'double-top'
                    ? topNavbarBreakpoint
                    : true
            }
        >
            {navbarPosition === 'double-top' ? (
                <div className="w-100">
                    <div className="d-flex flex-between-center">
                        <NavbarTopElements
                            navbarCollapsed={navbarCollapsed}
                            navbarPosition={navbarPosition}
                            handleBurgerMenu={handleBurgerMenu}
                            burgerMenuRef={burgerMenuRef}
                            notificaciones={notificaciones}
                            notificacionesLiberados={notificacionesLiberados}
                            isAllRead={isAllRead}
                            isAllReadLiberados={isAllReadLiberados}
                            hayNotificacionesNoLeidas={hayNotificacionesNoLeidas}
                            setIsAllRead={setIsAllRead}
                            setIsAllReadLiberados={setIsAllReadLiberados}
                            obtenerNotificaciones={obtenerNotificaciones}
                            lastNotf={lastNotf}
                            lastNotfLiberados={lastNotfLiberados}
                            setShowReleaseModal={setShowReleaseModal}
                        />
                    </div>
                    <hr className="my-2 d-none d-lg-block" />
                    <Navbar.Collapse in={navbarCollapsed} className="scrollbar py-2">
                        <Nav navbar>
                            <NavbarTopDropDownMenus />
                        </Nav>
                    </Navbar.Collapse>
                </div>
            ) : (
                <NavbarTopElements
                    navbarCollapsed={navbarCollapsed}
                    navbarPosition={navbarPosition}
                    handleBurgerMenu={handleBurgerMenu}
                    burgerMenuRef={burgerMenuRef}
                    notificaciones={notificaciones}
                    notificacionesLiberados={notificacionesLiberados}
                    setIdLead={setIdLead}
                    setShowModalSeguimientoLead={setShowModalSeguimientoLead}
                    isAllRead={isAllRead}
                    isAllReadLiberados={isAllReadLiberados}
                    hayNotificacionesNoLeidas={hayNotificacionesNoLeidas}
                    setIsAllRead={setIsAllRead}
                    setIsAllReadLiberados={setIsAllReadLiberados}
                    obtenerNotificaciones={obtenerNotificaciones}
                    lastNotf={lastNotf}
                    lastNotfLiberados={lastNotfLiberados}
                    setShowReleaseModal={setShowReleaseModal}
                />
            )}
        </Navbar>
    );
};

const NavbarTopElements = ({
    navbarPosition,
    handleBurgerMenu,
    navbarCollapsed,
    notificaciones,
    notificacionesLiberados,
    setIdLead,
    setShowModalSeguimientoLead,
    isAllRead,
    setIsAllRead,
    isAllReadLiberados,
    setIsAllReadLiberados,
    hayNotificacionesNoLeidas,
    obtenerNotificaciones,
    lastNotf,
    lastNotfLiberados,
    setShowReleaseModal
}) => {
    const burgerMenuRef = useRef();
    
    return (
        <>
            
            <div className="d-flex flex-wrap align-items-center w-100 position-relative">
            
                <Navbar.Toggle
                    ref={burgerMenuRef}
                    className={classNames('toggle-icon-wrapper me-md-3 me-2 order-0', {
                        'd-lg-none':
                            navbarPosition === 'top' || navbarPosition === 'double-top',
                        [`d-${navbarBreakPoint}-none`]:
                            navbarPosition === 'vertical' || navbarPosition === 'combo'
                    })}
                    as="div"
                >
                    <button
                        className="navbar-toggler-humburger-icon btn btn-link d-flex flex-center"
                        onClick={handleBurgerMenu}
                        id="burgerMenu"
                    >
                        <span className="navbar-toggle-icon">
                            <span className="toggle-line" />
                        </span>
                    </button>
                </Navbar.Toggle>

                <Logo at="navbar-top" width={40} id="topLogo" className="order-1" />

                {(navbarPosition === 'top' || navbarPosition === 'combo') && (
                    <Navbar.Collapse
                        in={navbarCollapsed}
                        className="scrollbar pb-3 pb-lg-0 order-lg-2"
                    >
                        <Nav navbar>
                            <NavbarTopDropDownMenus />
                        </Nav>
                    </Navbar.Collapse>
                )}
                
                {!(navbarPosition === 'top' || navbarPosition === 'combo') && (
                    <Nav
                        navbar
                        className="align-items-center d-block w-100 w-lg-auto order-4 order-lg-2 mt-2 mt-lg-0"
                        as="ul"
                    >
                        <Nav.Item as="li">
                            <SearchBox autoCompleteItem={autoCompleteInitialItem} />
                        </Nav.Item>
                    </Nav>
                )}

                <div className="ms-auto order-2 order-lg-3">
                    <TopNavRightSideNavItem
                        notificaciones={notificaciones}
                        notificacionesLiberados={notificacionesLiberados}
                        setIdLead={setIdLead}
                        setShowModalSeguimientoLead={setShowModalSeguimientoLead}
                        isAllRead={isAllRead}
                        setIsAllRead={setIsAllRead}
                        isAllReadLiberados={isAllReadLiberados}
                        setIsAllReadLiberados={setIsAllReadLiberados}
                        obtenerNotificaciones={obtenerNotificaciones}
                        hayNotificacionesNoLeidas={hayNotificacionesNoLeidas}
                        lastNotf={lastNotf}
                        lastNotfLiberados={lastNotfLiberados}
                        setShowReleaseModal={setShowReleaseModal}
                    />
                </div>
            </div>
        </>
    );
};

NavbarTopElements.propTypes = {
    navbarPosition: PropTypes.string,
    handleBurgerMenu: PropTypes.func,
    navbarCollapsed: PropTypes.bool,
    notificaciones: PropTypes.array,
    notificacionesLiberados: PropTypes.array,
    setIdLead: PropTypes.func,
    setShowModalSeguimientoLead: PropTypes.func,
    isAllRead: PropTypes.number,
    setIsAllRead: PropTypes.func,
    isAllReadLiberados: PropTypes.number,
    setIsAllReadLiberados: PropTypes.func,
    hayNotificacionesNoLeidas: PropTypes.func,
    obtenerNotificaciones: PropTypes.func,
    lastNotf: PropTypes.number,
    lastNotfLiberados: PropTypes.number,
    setShowReleaseModal: PropTypes.func
};

NavbarTop.propTypes = {
    notificaciones: PropTypes.array,
    notificacionesLiberados: PropTypes.array,
    setIdLead: PropTypes.func,
    setShowModalSeguimientoLead: PropTypes.func,
    isAllRead: PropTypes.number,
    setIsAllRead: PropTypes.func,
    isAllReadLiberados: PropTypes.number,
    setIsAllReadLiberados: PropTypes.func,
    hayNotificacionesNoLeidas: PropTypes.func,
    obtenerNotificaciones: PropTypes.func,
    lastNotf: PropTypes.number,
    lastNotfLiberados: PropTypes.number,
    setShowReleaseModal: PropTypes.func
};

export default NavbarTop;
